<template>
    <div class="final-score">
        <p class="final-score final-score__text">
            {{ $t('predictors.details.finalScoreText') }}
        </p>
        <p class="final-score final-score__number">{{ finalScoreFormatted }}</p>
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'prediction-outcome-american-football',
    computed: {
        ...mapGetters('predictorSportEvents', ['getSportEventOutcomeFormatted']),

        finalScoreFormatted() {
            return this.getSportEventOutcomeFormatted || this.$t('predictors.details.awaitingScore');
        },
    },
};
</script>

<style lang="scss" scoped>
.final-score {
    font-family: Nunito;
    color: $daintree-color;
    text-align: center;

    &__text {
        font-size: 1.1rem;
        margin: 0;
    }

    &__number {
        font-size: 2.1rem;
        margin: 0;
        font-weight: bold;
    }
}
</style>